module.exports = __webpack_public_path__ + "static/laptop-mockup-11-5ad2ca5de6d9a93bc92e6f79742c1ebd.png";